import {
  validateEvidenceLabConfig,
  type EvidenceLabConfig,
} from '../minigames/evidence-lab/EvidenceLabConfig.js';

export const PLANT_GROWTH_INVESTIGATION: EvidenceLabConfig = {
  id: 'plant-growth-conditions-1',
  skillId: 'science-plant-needs-1',
  question: 'Which modeled conditions supported the strongest plant growth?',
  subjects: [
    {
      id: 'light-water',
      label: 'LIGHT + WATER',
      observation: 'The seedling grew 8 cm and formed six healthy green leaves.',
      evidenceId: 'both-tall-green',
    },
    {
      id: 'water-shade',
      label: 'WATER + SHADE',
      observation: 'The seedling grew 2 cm and formed two pale leaves.',
      evidenceId: 'water-short-pale',
    },
    {
      id: 'light-dry',
      label: 'LIGHT + NO WATER',
      observation: 'The seedling grew 1 cm and its two leaves wilted.',
      evidenceId: 'light-short-wilted',
    },
  ],
  conclusions: [
    { id: 'both-best', text: 'Light and water together supported the strongest growth.' },
    { id: 'shade-best', text: 'Water and shade supported the strongest growth.' },
    { id: 'dry-best', text: 'Light without water supported the strongest growth.' },
  ],
  correctConclusionId: 'both-best',
  requiredEvidenceIds: ['both-tall-green', 'water-short-pale', 'light-short-wilted'],
  hints: [
    'Record the height and leaf condition in all three bays.',
    'Strong growth means taller growth with healthy green leaves.',
    'The light-and-water seedling was tallest and had the most healthy leaves.',
  ],
  evidenceExplanation:
    'The light-and-water bay produced the tallest seedling with the most healthy green leaves.',
  successMessage: 'The Growth House powers on and the healthy vines climb!',
  restorationEvent: 'plant-growth-house-restored',
};

validateEvidenceLabConfig(PLANT_GROWTH_INVESTIGATION);
